import React, { useState } from 'react'
import { Form, Button, Icon } from 'semantic-ui-react'
import { Modal } from 'react-bootstrap'
import JobInformation from './JobInformation'
import AdminNotes from './AdminNotes'
import Honorarium from './Honorarium'
import ZoomInformation from './ZoomInformation'
import PaymentMethods from './PaymentMethods'
import Description from './Description'
import Message from './Message'
import Alert from '../../../Alert'
import './style.css'

const PaymentInfo = ({ job, payment, updatePayment, updatePage }) => {
    const [error, setError] = useState(null)

    const onNext = () => {
        if (!job.user.expert.stripeAccount.isConnected) {
            if (!payment.method) {
                setError({
                    header: 'Missing required field',
                    body: 'Please select a payment method',
                })
                return
            }
        } else {
            updatePayment({ method: 'Stripe' })
        }
        if (payment.method === 'Check') {
            updatePage('CHECK')
        } else {
            updatePage('CREDIT')
        }
    }
    const onBack = () => updatePage(null)
    return (
        <Modal.Body>
            {error && (
                <Alert
                    show={true}
                    header={error.header}
                    body={error.body}
                    onClose={() => setError(null)}
                />
            )}
            <Form>
                <JobInformation job={job} />
                <AdminNotes job={job} />
                {job.project.type === 'Interview' && (
                    <ZoomInformation
                        job={job}
                        payment={payment}
                        updatePayment={updatePayment}
                    />
                )}
                <Honorarium
                    payment={payment}
                    updatePayment={updatePayment}
                    job={job}
                />
                <Description payment={payment} updatePayment={updatePayment} />
                {!job.user.expert.stripeAccount.isConnected && (
                    <PaymentMethods
                        payment={payment}
                        updatePayment={updatePayment}
                        job={job}
                    />
                )}
            </Form>
            <br />
            <Message
                job={job}
                payment={payment}
                updatePayment={updatePayment}
            />
            <Modal.Footer>
                <Button icon basic onClick={onBack}>
                    <Icon name="angle left" />
                </Button>
                <Button onClick={onNext}>Next</Button>
            </Modal.Footer>
        </Modal.Body>
    )
}

export default PaymentInfo
